const settings = {
	endpoint: 'https://adxpace.com/api'
	// endpoint: 'https://testing.adxpace.com/api'
	// endpoint: 'http://localhost:3000/api'
}

export { settings };
